import Kafka from "@/images/apache-kafka/apache-kafka@2x.png";
import AcrylData from "@/images/apps/AcrylData.svg";
import AcrylData2x from "@/images/apps/AcrylData@2x.svg";
import Airbyte from "@/images/apps/Airbyte.svg";
import Airbyte2x from "@/images/apps/Airbyte@2x.svg";
import Airflow from "@/images/apps/Airflow.svg";
import Airflow2x from "@/images/apps/Airflow@2x.svg";
import Alteryx from "@/images/apps/Alteryx.svg";
import Alteryx2x from "@/images/apps/Alteryx@2x.svg";
import AMAZONS3 from "@/images/apps/amazons3.png";
import AMAZONS32x from "@/images/apps/amazons3@2x.png";
import ApacheTomcat from "@/images/apps/ApacheTomcat.svg";
import ApacheTomcat2x from "@/images/apps/ApacheTomcat@2x.svg";
import Aurora from "@/images/apps/aurora.png";
import AWS from "@/images/apps/aws.png";
import AWS2x from "@/images/apps/aws@2x.png";
import AWSSageMaker from "@/images/apps/AWSSageMaker.svg";
import AWSSageMaker2x from "@/images/apps/AWSSageMaker@2x.svg";
import Azure from "@/images/apps/azure.svg";
import BedRock from "@/images/apps/bedrock.png";
import BigQuery from "@/images/apps/BigQuery.png";
import BigQuery2x from "@/images/apps/BigQuery@2x.png";
import Cortex from "@/images/apps/cortex.png";
import Databricks from "@/images/apps/databricks.png";
import Databricks2x from "@/images/apps/databricks@2x.png";
import DataBuildTool from "@/images/apps/DataBuildTool.svg";
import DataBuildTool2x from "@/images/apps/DataBuildTool@2x.svg";
import DataRobot from "@/images/apps/DataRobot.svg";
import DataRobot2x from "@/images/apps/DataRobot@2x.svg";
import Dbeaver from "@/images/apps/Dbeaver.svg";
import DellBoomi from "@/images/apps/DellBoomi.svg";
import DellBoomi2x from "@/images/apps/DellBoomi@2x.svg";
import DynamoDB from "@/images/apps/dynamodb.png";
import AWSEMR from "@/images/apps/emr.png";
import AWSEMR2x from "@/images/apps/emr@2x.png";
import Feast from "@/images/apps/Feast.svg";
import Feast2x from "@/images/apps/Feast@2x.svg";
import Glue from "@/images/apps/glue_data_pipeline.png";
import Glue2x from "@/images/apps/glue_data_pipeline@2x.png";
import GoogleLooker from "@/images/apps/GoogleLooker.svg";
import GoogleLooker2x from "@/images/apps/GoogleLooker@2x.svg";
import Intellij from "@/images/apps/Intellij.svg";
import Intellij2x from "@/images/apps/Intellij@2x.svg";
import Microsoft365 from "@/images/apps/microsoft365.svg";
import MonteCarloData from "@/images/apps/MonteCarloData.svg";
import MonteCarloData2x from "@/images/apps/MonteCarloData@2x.svg";
import MySQL from "@/images/apps/MySQL.png";
import MySQL2X from "@/images/apps/MySQL@2x.png";
import Oracle from "@/images/apps/oracle.png";
import OracleGoldenGate from "@/images/apps/OracleGoldenGate.svg";
import OracleSqlDeveloper from "@/images/apps/OracleSqlDeveloper.svg";
import PostgresSQL from "@/images/apps/postgresql.png";
import PostgresSQL2x from "@/images/apps/postgresql@2x.png";
import PowerBi from "@/images/apps/PowerBI.png";
import PowerBi2x from "@/images/apps/PowerBI@2x.png";
import PowerMTA from "@/images/apps/PowerMTA.svg";
import PowerMTA2x from "@/images/apps/PowerMTA@2x.svg";
import Python from "@/images/apps/Python.svg";
import QlikView from "@/images/apps/QlikView.svg";
import QlikView2x from "@/images/apps/QlikView@2x.svg";
import SapHANA from "@/images/apps/SapHANA.svg";
import Saviynt from "@/images/apps/Saviynt.svg";
import Saviynt2x from "@/images/apps/Saviynt@2x.svg";
import Sigma from "@/images/apps/Sigma.svg";
import Snowflake2x from "@/images/apps/snowflake@2x.png";
import SnowPark from "@/images/apps/snowpark.png";
import Spark from "@/images/apps/Spark.svg";
import Spark2x from "@/images/apps/Spark@2x.svg";
import Splunk from "@/images/apps/Splunk.svg";
import Splunk2x from "@/images/apps/Splunk@2x.svg";
import SqlBackupFree from "@/images/apps/sqlbackupfree.png";
import SqlPipe from "@/images/apps/sqlpipe.png";
import Sqlsafebackup from "@/images/apps/sqlsafebackup.png";
import SQLServerManagementStudio from "@/images/apps/ssms.png";
import Streamlit from "@/images/apps/Streamlit.svg";
import Streamlit2x from "@/images/apps/Streamlit@2x.svg";
import Tableau from "@/images/apps/tableau.png";
import Tableau2x from "@/images/apps/tableau@2x.png";
import Tanuki from "@/images/apps/Tanuki.svg";
import Tanuki2x from "@/images/apps/Tanuki@2x.svg";
import VisualStudio from "@/images/apps/VisualStudio.svg";
import VisualStudio2x from "@/images/apps/VisualStudio@2x.svg";
import AcrylDataSmall from "@/images/datasources/AcrylData.svg";
import AirbyteSmall from "@/images/datasources/Airbyte.svg";
import AirflowSmall from "@/images/datasources/Airflow.svg";
import AlteryxSmall from "@/images/datasources/Alteryx.svg";
import ApacheTomcatSmall from "@/images/datasources/ApacheTomcat.svg";
import AuroraSmall from "@/images/datasources/aurora.png";
import AWSSageMakerSmall from "@/images/datasources/AWSSageMaker.svg";
import BigQuerySmall from "@/images/datasources/bigquery.png";
import DatabricksSmall from "@/images/datasources/databicks.png";
import DataBuildToolSmall from "@/images/datasources/DataBuildTool.svg";
import DataRobotSmall from "@/images/datasources/DataRobot.svg";
import DellBoomiSmall from "@/images/datasources/DellBoomi.svg";
import DremioImage from "@/images/datasources/dreamio.png";
import DynamoDBSmall from "@/images/datasources/dynamodb.png";
import EMRSmall from "@/images/datasources/emr.png";
import FeastSmall from "@/images/datasources/Feast.svg";
import GlueSmall from "@/images/datasources/glue.png";
import GoogleLookerSmall from "@/images/datasources/GoogleLooker.svg";
import IntellijSmall from "@/images/datasources/Intellij.svg";
import KafkaSmall from "@/images/datasources/kafka.png";
import MonteCarloDataSmall from "@/images/datasources/MonteCarloData.svg";
import MYSqlSmall from "@/images/datasources/mysql.png";
import OracleSmall from "@/images/datasources/oracle.png";
import PostgresSmall from "@/images/datasources/postgresql.png";
import PowerBISmall from "@/images/datasources/PowerBI.png";
import PowerMTASmall from "@/images/datasources/PowerMTA.svg";
import QlikViewSmall from "@/images/datasources/QlikView.svg";
import AWSSmall from "@/images/datasources/redshift.png";
import AMAZONES3Small from "@/images/datasources/s3.png";
import SaviyntSmall from "@/images/datasources/Saviynt.svg";
import SnowflakeSmall from "@/images/datasources/snowflake.png";
import SparkSmall from "@/images/datasources/Spark.svg";
import SplunkSmall from "@/images/datasources/Splunk.svg";
import SQLServerSmall from "@/images/datasources/sqlserver.png";
import StreamlitSmall from "@/images/datasources/Streamlit.svg";
import TanukiSmall from "@/images/datasources/Tanuki.svg";
import unregisteredIcon from "@/images/datasources/unregistered.svg";
import VisualStudioSmall from "@/images/datasources/VisualStudio.svg";
import tlxIcon from "@/images/logo-sx.png";
import SQLServer from "@/images/sql/sql@2x.png";
import { isDemoEnvironment } from "@/libs/store";
import { ConfigParameter, IAccount } from "@/types/api";
import { TRUSTLOGIX } from "./constants";

export enum AccountTypes {
  AWS = "aws",
  Databricks = "databricks",
  Glue = "glue_data_pipeline",
  Snowflake = "snowflake",
  MySQL = "mysql",
  EMR = "emr",
  PostgreSQL = "postgresql",
  SQLServer = "sqlserver",
  Kafka = "kafka",
  Aurora = "aurora",
  BigQuery = "bigquery",
  DynamoDB = "dynamodb",
  Tableau = "tableau",
  AmazonS3 = "s3",
  PowerBi = "powerbi",
  Vscode = "vscode",
  StreamLit = "streamlit",
  Splunk = "splunk",
  Sigma = "sigma",
  Saviynt = "savynt",
  TanukiSoftware = "tanukisoftware",
  Oracle = "oracle",
  QlikView = "qlik",
  GoogleLooker = "looker",
  MonteCarloData = "monte_carlo",
  AcrylData = "acryl_datahub",
  Airbyte = "airbyte",
  Airflow = "airflow",
  AWSSageMaker = "amazonsagemaker",
  PowerMTA = "pmta",
  DellBoomi = "boomi",
  Intellij = "intellij",
  DataRobot = "datarobot",
  DataBuildTool = "dbt",
  Feast = "feast",
  Alteryx = "alteryx",
  Spark = "spark",
  ApacheTomcat = "catalina",
  Sqlpipe = "sqlpipe",
  SQLServerManagementStudio = "sql server management studio",
  SqlBackupFree = "sqlbackupfree",
  Sqlsafebackup = "sqlsafebackup",
  AWSBedRock = "AWS Bedrock",
  SnowPark = "Snowpark",
  Cortex = "Cortex",
  Azure = "azure",
  SapHANA = "SapHANA",
  OracleSqlDeveloper = "oracleSqlDeveloper",
  Dbeaver = "Dbeaver",
  Python = "python",
  OracleGoldenGate = "oracleGoldenGate",
  Dremio = "dremio",
  Microsoft365 = "microsoft365",
}

export interface IService {
  img: string;
  img2: string;
  img3: string;
  value: AccountTypes;
  enabled: boolean;
  trustletConfig: boolean;
  text?: string;
  isDemo?: boolean;
  monitoring?: boolean;
  isMonitoringDisabled?: boolean;
  reportType?: "CIS" | "LOGIN_ACTIVITY";
  assumeRole?: boolean;
  accessPolicy?: boolean;
  recommendation?: boolean;
  dataClassification?: boolean;
  whitelist?: boolean;
  privacyPolicy?: boolean;
  accessAnalyzer?: boolean;
  health?: boolean;
  dataRisks?: boolean;
  isDataRisksDisabled?: boolean;
  dataSprawl?: boolean;
  isTrial?: boolean;
  isFreemium?: boolean;
  hasSettings?: boolean;
  userDefinedFunction?: boolean;
  trustApp?: boolean;
  isTrustDSPM?: boolean;
  attributeManagement?: boolean;
  tagManagement?: boolean;
  hasVirtualAttribute?: boolean;
  hasNewAccessPolicy?: boolean;
  hasAbacPolicy?: boolean;
  hasRiskThreshold?: boolean;
  hasOverview?: boolean;
  hasPolicySync?: boolean;
  feature?: ConfigParameter;
}

const services: IService[] = (() => {
  const isDemo = isDemoEnvironment();
  return [
    {
      img: AWS,
      img2: AWS2x,
      img3: AWSSmall,
      value: AccountTypes.AWS,
      enabled: true,
      whitelist: true,
      dataClassification: !isDemo,
      assumeRole: true,
      accessPolicy: true,
      dataRisks: isDemo,
      trustletConfig: true,
      monitoring: isDemo,
      reportType: isDemo,
    },
    {
      img: DremioImage,
      img2: DremioImage,
      img3: DremioImage,
      value: AccountTypes.Dremio,
      enabled: true,
      whitelist: false,
      dataClassification: false,
      assumeRole: false,
      accessPolicy: true,
      hasNewAccessPolicy: true,
      hasAbacPolicy: true,
      feature: "isDremioEnabled",
    },
    {
      img: Microsoft365,
      img2: Microsoft365,
      img3: Microsoft365,
      value: AccountTypes.Microsoft365,
      enabled: true,
      whitelist: false,
      dataClassification: false,
      assumeRole: false,
      accessPolicy: true,
      hasNewAccessPolicy: true,
      hasAbacPolicy: true,
      feature: "isMicrosoft365Enabled",
    },
    {
      img: Databricks,
      img2: Databricks2x,
      img3: DatabricksSmall,
      value: AccountTypes.Databricks,
      enabled: true,
      whitelist: true,
      dataClassification: false,
      assumeRole: false,
      accessPolicy: true,
      accessAnalyzer: true,
      dataRisks: true,
      dataSprawl: isDemo,
      trustletConfig: false,
      monitoring: true,
      recommendation: isDemo,
      reportType: isDemo,
      isTrial: true,
      isFreemium: true,
      hasSettings: true,
      userDefinedFunction: true,
      trustApp: true,
      attributeManagement: true,
      tagManagement: true,
      isTrustDSPM: true,
      hasVirtualAttribute: true,
      hasAbacPolicy: true,
      hasNewAccessPolicy: true,
      hasRiskThreshold: true,
      hasOverview: true,
      hasPolicySync: true,
    },
    {
      img: Glue,
      img2: Glue2x,
      img3: GlueSmall,
      value: AccountTypes.Glue,
      enabled: false,
      assumeRole: true,
      accessPolicy: false,
      dataRisks: false,
      dataClassification: true,
      privacyPolicy: true,
      trustletConfig: true,
    },
    {
      img: Snowflake2x,
      img2: Snowflake2x,
      img3: SnowflakeSmall,
      value: AccountTypes.Snowflake,
      reportType: "LOGIN_ACTIVITY",
      monitoring: true,
      accessPolicy: true,
      dataRisks: true,
      accessAnalyzer: true,
      dataSprawl: true,
      recommendation: true,
      enabled: true,
      whitelist: true,
      dataClassification: true,
      trustletConfig: false,
      health: isDemo,
      isTrial: true,
      isFreemium: true,
      hasSettings: true,
      userDefinedFunction: true,
      trustApp: true,
      isTrustDSPM: true,
      hasVirtualAttribute: true,
      hasNewAccessPolicy: true,
      hasAbacPolicy: true,
      hasRiskThreshold: true,
      hasOverview: true,
      hasPolicySync: true,
    },
    {
      img: MySQL,
      img2: MySQL2X,
      img3: MYSqlSmall,
      value: AccountTypes.MySQL,
      reportType: "LOGIN_ACTIVITY",
      monitoring: true,
      accessPolicy: true,
      enabled: true,
      whitelist: true,
      dataClassification: false,
      dataRisks: true,
      accessAnalyzer: true,
      trustletConfig: true,
      tagManagement: true,
      isTrustDSPM: isDemo,
    },
    {
      img: AWSEMR,
      img2: AWSEMR2x,
      img3: EMRSmall,
      value: AccountTypes.EMR,
      enabled: false,
      assumeRole: true,
      dataClassification: true,
      privacyPolicy: true,
      trustletConfig: true,
      dataRisks: false,
      accessPolicy: true,
    },
    {
      img: PostgresSQL,
      img2: PostgresSQL2x,
      img3: PostgresSmall,
      value: AccountTypes.PostgreSQL,
      accessPolicy: true,
      reportType: "CIS",
      monitoring: true,
      enabled: true,
      whitelist: true,
      dataClassification: true,
      dataRisks: true,
      trustletConfig: true,
    },
    {
      img: SQLServer,
      img2: SQLServer,
      img3: SQLServerSmall,
      value: AccountTypes.SQLServer,
      reportType: "CIS",
      accessPolicy: true,
      assumeRole: false,
      dataRisks: true,
      enabled: true,
      whitelist: true,
      dataClassification: false,
      monitoring: true,
      trustletConfig: false,
      accessAnalyzer: isDemo,
      dataSprawl: isDemo,
      isTrial: true,
      trustApp: true,
      attributeManagement: true,
      tagManagement: true,
      isTrustDSPM: isDemo,
      hasAbacPolicy: true,
      hasNewAccessPolicy: true,
      hasOverview: true,
    },
    {
      img: Kafka,
      img2: Kafka,
      img3: KafkaSmall,
      value: AccountTypes.Kafka,
      enabled: false,
      accessPolicy: true,
      trustletConfig: true,
      dataRisks: true,
    },
    {
      img: Aurora,
      img2: Aurora,
      img3: AuroraSmall,
      value: AccountTypes.Aurora,
      enabled: true,
      whitelist: true,
      dataClassification: true,
      assumeRole: true,
      accessPolicy: true,
      trustletConfig: true,
      monitoring: isDemo,
      reportType: isDemo,
      dataRisks: false,
    },
    {
      img: BigQuery,
      img2: BigQuery2x,
      img3: BigQuerySmall,
      value: AccountTypes.BigQuery,
      isDemo: true,
      enabled: false,
      assumeRole: false,
      accessPolicy: true,
      trustletConfig: true,
      monitoring: true,
      reportType: isDemo,
      dataRisks: false,
    },
    {
      img: DynamoDB,
      img2: DynamoDB,
      img3: DynamoDBSmall,
      value: AccountTypes.DynamoDB,
      enabled: true,
      whitelist: true,
      dataClassification: true,
      reportType: "CIS",
      monitoring: true,
      trustletConfig: true,
      dataRisks: true,
    },
    {
      img: Tableau,
      img2: Tableau2x,
      img3: Tableau,
      value: AccountTypes.Tableau,
      isDemo: true,
      enabled: false,
      reportType: "CIS",
      monitoring: true,
      accessPolicy: true,
      trustletConfig: true,
      dataRisks: false,
    },
    {
      img: AMAZONS3,
      img2: AMAZONS32x,
      img3: AMAZONES3Small,
      value: AccountTypes.AmazonS3,
      enabled: true,
      whitelist: true,
      dataClassification: true,
      assumeRole: false,
      accessPolicy: isDemo,
      monitoring: true,
      trustletConfig: true,
      reportType: "LOGIN_ACTIVITY",
      health: isDemo,
      dataRisks: true,
    },
    {
      img: PowerBi,
      img2: PowerBi2x,
      img3: PowerBISmall,
      value: AccountTypes.PowerBi,
      isTrial: true,
      enabled: true,
      whitelist: true,
      dataClassification: false,
      assumeRole: false,
      accessPolicy: true,
      monitoring: true,
      trustletConfig: false,
      health: false,
      dataRisks: true,
      isMonitoringDisabled: true,
      isDataRisksDisabled: true,
      hasAbacPolicy: true,
    },
    {
      img: VisualStudio,
      img2: VisualStudio2x,
      img3: VisualStudioSmall,
      value: AccountTypes.Vscode,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Streamlit,
      img2: Streamlit2x,
      img3: StreamlitSmall,
      value: AccountTypes.StreamLit,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Splunk,
      img2: Splunk2x,
      img3: SplunkSmall,
      value: AccountTypes.Splunk,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Sigma,
      img2: Sigma,
      img3: Sigma,
      value: AccountTypes.Sigma,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Saviynt,
      img2: Saviynt2x,
      img3: SaviyntSmall,
      value: AccountTypes.Saviynt,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Tanuki,
      img2: Tanuki2x,
      img3: TanukiSmall,
      value: AccountTypes.TanukiSoftware,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Oracle,
      img2: Oracle,
      img3: OracleSmall,
      value: AccountTypes.Oracle,
      enabled: true,
      whitelist: true,
      dataClassification: false,
      monitoring: true,
      accessPolicy: true,
      hasNewAccessPolicy: true,
      dataRisks: true,
      accessAnalyzer: false,
      dataSprawl: isDemo,
      recommendation: false,
      trustletConfig: false,
      hasAbacPolicy: true,
      health: false,
      isTrial: false,
      isFreemium: false,
      tagManagement: true,
      isTrustDSPM: isDemo,
    },
    {
      img: QlikView,
      img2: QlikView2x,
      img3: QlikViewSmall,
      value: AccountTypes.QlikView,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: GoogleLooker,
      img2: GoogleLooker2x,
      img3: GoogleLookerSmall,
      value: AccountTypes.GoogleLooker,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: MonteCarloData,
      img2: MonteCarloData2x,
      img3: MonteCarloDataSmall,
      value: AccountTypes.MonteCarloData,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Airbyte,
      img2: Airbyte2x,
      img3: AirbyteSmall,
      value: AccountTypes.Airbyte,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Airflow,
      img2: Airflow2x,
      img3: AirflowSmall,
      value: AccountTypes.Airflow,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: AWSSageMaker,
      img2: AWSSageMaker2x,
      img3: AWSSageMakerSmall,
      value: AccountTypes.AWSSageMaker,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: PowerMTA,
      img2: PowerMTA2x,
      img3: PowerMTASmall,
      value: AccountTypes.PowerMTA,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: DellBoomi,
      img2: DellBoomi2x,
      img3: DellBoomiSmall,
      value: AccountTypes.DellBoomi,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Intellij,
      img2: Intellij2x,
      img3: IntellijSmall,
      value: AccountTypes.Intellij,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: DataRobot,
      img2: DataRobot2x,
      img3: DataRobotSmall,
      value: AccountTypes.DataRobot,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: DataBuildTool,
      img2: DataBuildTool2x,
      img3: DataBuildToolSmall,
      value: AccountTypes.DataBuildTool,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Feast,
      img2: Feast2x,
      img3: FeastSmall,
      value: AccountTypes.Feast,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Spark,
      img2: Spark2x,
      img3: SparkSmall,
      value: AccountTypes.Spark,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: ApacheTomcat,
      img2: ApacheTomcat2x,
      img3: ApacheTomcatSmall,
      value: AccountTypes.ApacheTomcat,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: AcrylData,
      img2: AcrylData2x,
      img3: AcrylDataSmall,
      value: AccountTypes.AcrylData,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Alteryx,
      img2: Alteryx2x,
      img3: AlteryxSmall,
      value: AccountTypes.Alteryx,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: SqlPipe,
      img2: SqlPipe,
      img3: SqlPipe,
      value: AccountTypes.Sqlpipe,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: SQLServerManagementStudio,
      img2: SQLServerManagementStudio,
      img3: SQLServerManagementStudio,
      value: AccountTypes.SQLServerManagementStudio,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: SqlBackupFree,
      img2: SqlBackupFree,
      img3: SqlBackupFree,
      value: AccountTypes.SqlBackupFree,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Sqlsafebackup,
      img2: Sqlsafebackup,
      img3: Sqlsafebackup,
      value: AccountTypes.Sqlsafebackup,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: BedRock,
      img2: BedRock,
      img3: BedRock,
      value: AccountTypes.AWSBedRock,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: SnowPark,
      img2: SnowPark,
      img3: SnowPark,
      value: AccountTypes.SnowPark,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Cortex,
      img2: Cortex,
      img3: Cortex,
      value: AccountTypes.Cortex,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Azure,
      img2: Azure,
      img3: Azure,
      value: AccountTypes.Azure,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: SapHANA,
      img2: SapHANA,
      img3: SapHANA,
      value: AccountTypes.SapHANA,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: OracleSqlDeveloper,
      img2: OracleSqlDeveloper,
      img3: OracleSqlDeveloper,
      value: AccountTypes.OracleSqlDeveloper,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Dbeaver,
      img2: Dbeaver,
      img3: Dbeaver,
      value: AccountTypes.Dbeaver,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: Python,
      img2: Python,
      img3: Python,
      value: AccountTypes.Python,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
    {
      img: OracleGoldenGate,
      img2: OracleGoldenGate,
      img3: OracleGoldenGate,
      value: AccountTypes.OracleGoldenGate,
      enabled: false,
      assumeRole: false,
      accessPolicy: false,
      monitoring: false,
      trustletConfig: false,
      health: false,
      dataRisks: false,
    },
  ];
})() as IService[];

const defaultServices = {
  img: unregisteredIcon,
  img2: unregisteredIcon,
  img3: unregisteredIcon,
};

export const Charts = {
  StackedBar: [
    AccountTypes.AmazonS3,
    AccountTypes.DynamoDB,
    AccountTypes.Snowflake,
  ],

  Classifications: [AccountTypes.AmazonS3, AccountTypes.DynamoDB],

  isStackedBar(type: AccountTypes): "stackedBar" | "" {
    return Charts.StackedBar.includes(type) ? "stackedBar" : "";
  },

  isPieChart(type: AccountTypes): "pieChart" | "" {
    return Charts.StackedBar.includes(type) ? "pieChart" : "";
  },

  fetchApi(type: AccountTypes): boolean {
    return Charts.StackedBar.includes(type);
  },

  isClassificationType(type: AccountTypes): boolean {
    return Charts.Classifications.includes(type);
  },
};

export default services;

/**
 * Service definition for an account's `type`.
 *
 * Backed by a map built once, because callers reach for several fields of the
 * same service in a row — `getAccountTabKeys` alone calls thirteen of the
 * getters below for one account, and the switcher calls it once per row.
 */
const serviceByType = new Map(services.map(item => [item.value, item]));

const findService = (type?: string): IService | undefined =>
  type === undefined ? undefined : serviceByType.get(type as AccountTypes);

/**
 * Case-insensitive lookup: some `AccountTypes` values are mixed-case
 * ("AWS Bedrock"), and callers pass types in either case. First entry wins.
 */
const serviceByLowerType = services.reduce((map, item) => {
  const key = item.value.toLowerCase();
  if (!map.has(key)) map.set(key, item);
  return map;
}, new Map<string, IService>());

const findServiceIgnoreCase = (type?: string): IService | undefined =>
  type ? serviceByLowerType.get(type.toLowerCase()) : undefined;

export const getIcon = (type?: string, size?: number) => {
  if (type === TRUSTLOGIX) {
    return tlxIcon;
  }
  if (type) {
    const service = findServiceIgnoreCase(type) ?? defaultServices;

    if (size === 2) {
      return service?.img2;
    } else if (size === 3) {
      return service?.img3;
    } else {
      return service?.img;
    }
  }
};

/**
 * The catalogue mark for a known service `type`, or `undefined` — unlike
 * `getIcon`, it never substitutes the "unregistered" glyph, so a caller can
 * fall back to its own generic icon.
 */
export const getKnownServiceIcon = (type?: string): string | undefined =>
  findServiceIgnoreCase(type)?.img3;

/** A service type's display name ("Amazon Aurora"), else the raw type. */
export const getServiceLabel = (
  t: (key: string, options?: { defaultValue: string }) => string,
  type: string,
): string => t(`services.${type.toLowerCase()}`, { defaultValue: type });

export const getReport = (account: IAccount) =>
  findService(account.type)?.reportType;

export const getMonitoring = (account: IAccount) =>
  findService(account.type)?.monitoring;

export const getIsMonitoringDisabled = (account: IAccount) =>
  findService(account.type)?.isMonitoringDisabled;

export const getAccessPolicy = (account: IAccount) =>
  findService(account.type)?.accessPolicy;

export const getRecommendationPolicy = (account: IAccount) =>
  findService(account.type)?.recommendation;

export const getHealth = (account: IAccount) =>
  findService(account.type)?.health;

export const getPrivacyPolicy = (account: IAccount) =>
  findService(account.type)?.privacyPolicy;

export const getDataEntitlement = (account: IAccount) =>
  findService(account.type)?.accessAnalyzer;

export const getDataRisks = (account: IAccount) =>
  findService(account.type)?.dataRisks;

export const getIsDataRisksDisabled = (account: IAccount) =>
  findService(account.type)?.isDataRisksDisabled;

export const getDataMovement = (account: IAccount) => {
  return findService(account.type)?.dataSprawl;
};

export const getDataClassification = (account: IAccount) =>
  findService(account.type)?.dataClassification;

export const getWhitelistEnabled = (account: IAccount) =>
  findService(account.type)?.whitelist;

export const getType = (account: IAccount) => findService(account.type)?.value;

export const getUpperCaseType = (account: IAccount) => {
  let type = findService(account.type)?.value || "";
  type = type === "aws" ? "redshift" : type;
  return type.toUpperCase();
};

export const hasTrustletConfig = (account: IAccount): boolean =>
  findService(account.type)?.trustletConfig as boolean;

export const hasFeature = (
  feature: keyof IService,
  account?: IAccount,
): boolean => {
  if (!account) return false;
  const service = findService(account.type);
  return service ? !!service[feature] : false;
};

export const getServiceList = (): string[] => {
  const isDemo = isDemoEnvironment();
  const data = isDemo
    ? services
    : services.filter(item => item.enabled && item.isDemo !== true);
  const servicesData: string[] = data.map(item => item.value) || [];
  if (!servicesData.includes("all")) {
    servicesData.unshift("all");
  }
  return servicesData;
};
